import { useFanSpeed } from "./useFanSpeed";
import { useUplinkInterval } from "./useUplinkInterval";

export { useFanSpeed, useUplinkInterval };
